import { render, staticRenderFns } from "./ActorDetailOPGlobal.vue?vue&type=template&id=a6ed8602&scoped=true&"
import script from "./ActorDetailOPGlobal.vue?vue&type=script&lang=js&"
export * from "./ActorDetailOPGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ed8602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
